// extracted by mini-css-extract-plugin
export var messageSideLeft = "_nx-1";
export var messageSideRight = "_nx-2";
export var orderLookupBubbleContainer = "_nx-0";
export var submitButton = "_nx-3";